import { isEmpty as _isEmpty, isEqual as _isEqual } from "lodash-es";

/** @private is the value an empty array? */
export const isEmptyArray = (value?: any) => Array.isArray(value) && value.length === 0;

/** @private is the value an empty array? */
export const isEmptyObject = (value?: object) => _isEmpty(value);

/** @private is the given object a Function? */

export const isFunction = (obj: any): obj is Function => typeof obj === "function";

/** @private is the given object an Object? */

export const isObject = (obj: any): obj is object => obj !== null && typeof obj === "object";

/** @private is the given object an integer? */
export const isInteger = (obj: any): boolean => String(Math.floor(Number(obj))) === obj;

/** @private is the given object a string? */
export const isString = (obj: any): obj is string =>
	Object.prototype.toString.call(obj) === "[object String]";

/** @private is the given object a NaN? */

export const isNaN = (obj: any): boolean => obj !== obj;

/** @private is the given object/value a promise? */
export const isPromise = (value: any): value is PromiseLike<any> =>
	isObject(value) && isFunction((value as any).then);

export const isEqual = _isEqual;
